import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-end col-sm-12" }
const _hoisted_2 = { class: "card card-flush mt-5" }
const _hoisted_3 = { class: "card-body table align-middle table-row-dashed fs-7 gy-1 dataTable no-footer pt-0 pb-0" }
const _hoisted_4 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_7 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_8 = { class: "d-flex justify-content-end" }
const _hoisted_9 = {
  class: "ms-2",
  "data-kt-filemanger-table": "copy_link"
}
const _hoisted_10 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_11 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_12 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-state-bg-light-primary fw-normal fs-7 w-auto",
  "data-kt-menu": "true"
}
const _hoisted_13 = { class: "card card-flush" }
const _hoisted_14 = { class: "card-body p-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_SupportMessageDrawer = _resolveComponent("SupportMessageDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-sm btn-primary fw-bolder",
        disabled: "",
        "data-kt-drawer-toggle": "true",
        "data-kt-drawer-target": "#kt_support_drawer_chat",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDrawer()))
      }, " Chat Support ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          onCurrentChange: _ctx.onCurrentChange,
          onSort: _ctx.onSort,
          onItemsPerPageChange: _ctx.onItemsPerPageChange,
          loading: _ctx.loading,
          rowsPerPage: _ctx.pagination.rowsPerPage
        }, {
          "cell-checkbox": _withCtx(({ row: tickets }) => [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: tickets.id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkedTickets) = $event))
              }, null, 8, _hoisted_5), [
                [_vModelCheckbox, _ctx.checkedTickets]
              ])
            ])
          ]),
          "cell-title": _withCtx(({ row: tickets }) => [
            _createTextVNode(_toDisplayString(tickets.title), 1)
          ]),
          "cell-status": _withCtx(({ row: tickets }) => [
            (tickets.status == 'pending')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(tickets.status), 1))
              : (tickets.status == 'completed')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(tickets.status), 1))
                : _createCommentVNode("", true)
          ]),
          "cell-created": _withCtx(({ row: tickets }) => [
            _createTextVNode(_toDisplayString(tickets.created), 1)
          ]),
          "cell-category": _withCtx(({ row: tickets }) => [
            _createTextVNode(_toDisplayString(tickets.category), 1)
          ]),
          "cell-expires_at": _withCtx(({ row: tickets }) => [
            _createTextVNode(_toDisplayString(tickets.expires_at), 1)
          ]),
          "cell-actions": _withCtx(({ row: tickets }) => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen052.svg" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(tickets.ticket_details), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["table-data", "table-header", "onCurrentChange", "onSort", "onItemsPerPageChange", "loading", "rowsPerPage"])
      ])
    ]),
    _createVNode(_component_SupportMessageDrawer)
  ], 64))
}